import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class VariablePayReportsService {
  headers;
  constructor(private http: HttpClient) { }

  /* Getting Headers */
  getHeaders() {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'access-token': localStorage.getItem('access-token'),
      'client': localStorage.getItem('client'),
      'expiry': localStorage.getItem('expiry'),
      'uid': localStorage.getItem('uid')
    });
  }

  /* Setting Headers */
  setHeaders(data) {
    if (data.headers.get('access-token') != null) {
      localStorage.setItem('access-token', data.headers.get('access-token'));
      localStorage.setItem('client', data.headers.get('client'));
      localStorage.setItem('expiry', data.headers.get('expiry'));
      localStorage.setItem('uid', data.headers.get('uid'));
    }
  }

  getAccountsList() {
    this.getHeaders();
    return this.http.get(environment.api_url + '/accounts', { headers: this.headers, observe: 'response' });
  }

  getAssessmentYearsList() {
    this.getHeaders();
    return this.http.get(environment.api_url + '/assessment_years', { headers: this.headers, observe: 'response' });
  }

  getVariablePayReports(apiParams) {
    this.getHeaders();
    return this.http.get(environment.api_url + '/variable_pays/reports', { headers: this.headers, params: apiParams, observe: 'response' });
  }

}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/services/variable-pay-reports.service.ts